export default "__VITE_ASSET__8540c886__"